import React, { Component, PropTypes } from 'react';
import Header from 'components/views/header/Header';
import Footer from 'components/views/footer/Footer';

import './htmlPage.scss';

export default class HtmlPage extends Component {

    fixHeight = (el) => {
        if(el) {
            el.style.height = "0px";
        }
    }

    render() {
        return (
            <table role='presentation' className={`page-container`}>
                <tbody>
                    <tr className={`page-header-container`}>
                        <td>
                            <Header/>
                        </td>
                    </tr>
                    <tr className={`page-content-container`}>
                        <td ref={this.fixHeight}>
                            <div className={`page-content`}>
                                {this.props.children}
                            </div>
                        </td>
                    </tr>
                    <tr className={`page-footer-container`}>
                        <td>
                            <Footer/>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/htmlPage/HtmlPage.js